import React from 'react';
import PropTypes from 'prop-types';
import {TAB_STATE} from '../ResultComparison.constants';
import './style.scss';

/**
 * ComparisonTabs:
 *  - Renders the comparison tabs [Predicted, Actual, Ideal]
 */
export function ComparisonTabs(props) {
  const renderTab = (tab) => (
    <Tab
      key={tab.value}
      label={tab.label}
      altText={tab.altText}
      className='comparsionTabs_item'
      value={tab.value}
      onClick={props.selectTab}
    />
  );

  const renderTabList = () => props.tabList.map(renderTab);

  const setWrapperClass = () => {
    const activeTabs = props.tabList
      .reduce(
        (list, tab) =>
          tab.state != TAB_STATE.TERITARY ? [...list, tab.value] : list,
        []
      )
      .join('_');
    return `comparsionTabs comparsionTabs-${activeTabs}`;
  };

  return <div className={setWrapperClass()}>{renderTabList()}</div>;
}

ComparisonTabs.propTypes = {
  /**
   * List of tabs to be displayed
   */
  tabList: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       *The label of the tab
       */
      label: PropTypes.string,
      /**
       * Unique Id to recognize the tab
       */
      value: PropTypes.string,
      /**
       * state of the tab
       */
      state: PropTypes.oneOf([
        TAB_STATE.TERITARY,
        TAB_STATE.SECONDARY,
        TAB_STATE.PRIMARY,
      ]),
    })
  ),
  /**
   * Callback function to invoke when a tab is selected
   */
  selectTab: PropTypes.func,
};

ComparisonTabs.defultProps = {
  tabList: [],
};

function Tab(props) {
  const onClick = () => props.onClick(props.value);

  return (
    <div className={props.className} onClick={onClick} aria-label={props.altText} tabIndex={0}>
      <h5>{props.label}</h5>
    </div>
  );
}

Tab.propTypes = {
  /**
   * ClassName to be set for the tab
   */
  className: PropTypes.string,
  /**
   *The label of the tab
   */
  label: PropTypes.string,
  /**
   * Unique Id to recognize the tab
   */
  value: PropTypes.string,
  /**
   * Function to invoke when clicked
   */
  onClick: PropTypes.func,
};
